import { Quote } from "lucide-react";

const BG =
  "https://images.unsplash.com/photo-1735847493430-244a0a9610d1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHx5b3V0aCUyMGxhY3Jvc3NlJTIwYWN0aW9uJTIwZGFya3xlbnwwfHx8fDE3NzkzMDAxMTB8MA&ixlib=rb-4.1.0&q=85";

const quotes = [
  {
    text:
      "He used to be the quiet kid on the bench. Now he runs the wing and shouts encouragement at his teammates. The jersey didn't do that — but it sure helps.",
    author: "Dana M.",
    role: "Mom · #7",
  },
  {
    text:
      "First game in the volt jerseys we were down 3-0. Came back to win 7-5. Coincidence? Probably. But I'm not changing the lineup.",
    author: "Coach Reggie",
    role: "Head Coach",
  },
  {
    text:
      "I wore the BSE tee to school on Monday. Three kids asked where I got it. So I just kept walking. That's energy.",
    author: "Jaden",
    role: "Midfielder · #11",
  },
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#0a0a0a] py-24 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-[0.08]">
        <img src={BG} alt="" className="w-full h-full object-cover" />
        <div className="absolute inset-0 bg-[#0a0a0a]" style={{ mixBlendMode: "multiply" }} />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 mb-14 md:mb-20">
          <div className="md:col-span-7">
            <div className="flex items-center gap-3 text-[10px] tracking-[0.3em] uppercase text-[#e11d2a] mb-5">
              <span className="inline-block w-8 h-px bg-[#e11d2a]" />
              <span>Word on the Field</span>
            </div>
            <h2 className="font-anton uppercase text-5xl sm:text-6xl md:text-7xl leading-[0.9] tracking-tight">
              Parents talk. <br />
              <span className="text-[#e11d2a]">Kids talk louder.</span>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {quotes.map((q, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="reveal relative bg-[#141414] border border-neutral-900 p-8 md:p-10 hover:border-[#e11d2a]/30 transition-colors flex flex-col"
              style={{ transitionDelay: `${i * 100}ms` }}
            >
              <Quote
                size={48}
                className="text-[#e11d2a] opacity-90"
                strokeWidth={1.5}
              />
              <blockquote className="mt-6 text-white text-base md:text-lg leading-relaxed flex-1">
                "{q.text}"
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-neutral-800">
                <div className="font-anton text-xl tracking-tight uppercase">
                  {q.author}
                </div>
                <div className="text-[10px] tracking-[0.25em] uppercase text-neutral-500 mt-1">
                  {q.role}
                </div>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
